import { Dispatch } from 'redux'
import {
  add as addAction,
  set as setAction,
  setLoading,
  update as updateAction
} from 'states/dux/amenity/actions'
import { Payload } from 'states/dux/amenity/types'
import { Action } from 'states/types'
import { Amenity } from 'types/amenity-booking'

type DispatchAction = (dispatch: Dispatch) => Action<Payload>

const set = (amenities: Amenity[]): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      setAction({
        loading: false,
        data: amenities
      })
    )
}

const update = (amenity: Amenity): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      updateAction({
        loading: false,
        data: [amenity]
      })
    )
}

const add = (amenity: Amenity): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> =>
    dispatch(
      addAction({
        loading: false,
        data: [amenity]
      })
    )
}

const loading = (loading = true): DispatchAction => {
  return (dispatch: Dispatch): Action<Payload> => dispatch(setLoading(loading))
}

export interface Operations {
  set: (amenities: Amenity[]) => DispatchAction
  add: (amenity: Amenity) => DispatchAction
  update: (amenity: Amenity) => DispatchAction
  loading: (loading: boolean) => DispatchAction
}

const operations: Operations = {
  set,
  add,
  update,
  loading
}

export { operations, set }
